export interface IConditionExpression {
    field?: string,
    operator?: string,
    value?: string
}